export default "__VITE_ASSET__pXENqzgG__"